import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Draggable } from 'gsap/Draggable';

export { gsap, ScrollTrigger, Draggable };

export function registerGsapPlugins() {
  gsap.registerPlugin(Draggable, ScrollTrigger);
}
